import { gql } from '@apollo/client';

// Operation names deliberately differ from the backend field names —
// see the operation-name ≠ field-name rule in the graphql-codegen skill.

export const CreateWhiteboardForLessonMutation = gql`
  mutation CreateWhiteboardForLesson($lessonId: ID!, $name: String) {
    createLessonWhiteboard(lessonId: $lessonId, name: $name) {
      success
      customErrors {
        code
        field
        message
      }
      whiteboard {
        id
        name
        sceneJson
        sceneVersion
      }
    }
  }
`;

export const LinkWhiteboardToLessonMutation = gql`
  mutation LinkWhiteboardToLesson($lessonId: ID!, $whiteboardId: ID!) {
    linkLessonWhiteboard(lessonId: $lessonId, whiteboardId: $whiteboardId) {
      success
      customErrors {
        code
        field
        message
      }
      whiteboard {
        id
        name
        sceneJson
        sceneVersion
      }
    }
  }
`;

export const SaveBoardSceneMutation = gql`
  mutation SaveBoardScene($whiteboardId: ID!, $sceneJson: String!, $expectedVersion: Int!) {
    saveWhiteboardScene(
      whiteboardId: $whiteboardId
      sceneJson: $sceneJson
      expectedVersion: $expectedVersion
    ) {
      success
      customErrors {
        code
        field
        message
      }
      sceneVersion
      whiteboard {
        id
        sceneVersion
      }
    }
  }
`;

export const RenameBoardMutation = gql`
  mutation RenameBoard($whiteboardId: ID!, $name: String!) {
    renameWhiteboard(whiteboardId: $whiteboardId, name: $name) {
      success
      customErrors {
        code
        field
        message
      }
      whiteboard {
        id
        name
      }
    }
  }
`;

export const UnlinkWhiteboardFromLessonMutation = gql`
  mutation UnlinkWhiteboardFromLesson($lessonId: ID!) {
    unlinkLessonWhiteboard(lessonId: $lessonId) {
      success
      customErrors {
        code
        field
        message
      }
    }
  }
`;

/**
 * Pushes ONE pasted/dropped scene image to S3 (spec 0010 rev.3). The scene
 * itself is saved without dataURLs; only the fileId reference stays on the
 * element. Multipart transport comes from apollo-upload-client's
 * createUploadLink, already wired in core/graphql/client.
 */
export const UploadBoardImageMutation = gql`
  mutation UploadBoardImage(
    $whiteboardId: ID!
    $fileId: String!
    $mimeType: String
    $file: Upload!
  ) {
    uploadWhiteboardFile(
      whiteboardId: $whiteboardId
      fileId: $fileId
      mimeType: $mimeType
      file: $file
    ) {
      success
      customErrors {
        code
        field
        message
      }
      file {
        fileId
        mimeType
        url
      }
    }
  }
`;

export const SaveSchoolLibraryMutation = gql`
  mutation SaveSchoolLibrary($itemsJson: String!, $expectedVersion: Int!) {
    saveWhiteboardLibrary(itemsJson: $itemsJson, expectedVersion: $expectedVersion) {
      success
      customErrors {
        code
        field
        message
      }
      version
    }
  }
`;
